import {Component, HostBinding, Input, OnInit} from '@angular/core';

@Component({
  selector: 'cmp-card-footer',
  template: `
<h6 class="footer-text-left mb-0 mr-3 float-left" *ngIf="title">{{title}}</h6>
<div class="footer-buttons-left header-buttons-left mb-0 float-left">
  <ng-content select="[left]"></ng-content>
</div>
<div class="footer-buttons-right buttons-group float-right">
  <ng-content select="[right]"></ng-content>
</div>
`,
  styles: [`.footer-buttons-left:empty,.footer-buttons-right:empty,.footer-text-left:empty{display:none}`]
})
export class CardFooterComponent implements OnInit {

  @HostBinding('class') classes = 'card-footer clearfix bg-white';
  @Input() title: any;

  constructor() {
  }

  ngOnInit() {
  }

}
